import type { Dispatch } from 'redux';
import { createActionFactory, Feature } from '../../../shared';

export const cancelMultiSelectClickedAction = createActionFactory<{}>(
    'CancelMultiSelectClickedAction',
    Feature.ContactManagement
);
export const startChatClickedAction = createActionFactory<{ imAddresses: string[] }>(
    'StartChatClickedAction',
    Feature.ContactManagement
);

export const cancelMultiSelect = (dispatch: Dispatch) => () =>
    dispatch(cancelMultiSelectClickedAction());

export const startChatWithPersonas = (dispatch: Dispatch) => (imAddresses: string[]) => {
    dispatch(startChatClickedAction({ imAddresses }));
    window.location.href = 'im:' + imAddresses.map(im => `<${im}>`).join('');
};
export type { Action } from '../../../shared';
